export default __webpack_public_path__ + "static/media/meleepot.6969e1aa.PNG";